import membershipApiClient from '@/services/membership';

class Users {
  getUserInfo = async () => {
    const response = await membershipApiClient.get('users/me');
    return response.data;
  };
  updateUserInfo = async (firstName: string, lastName: string, userId: string) => {
    const response = await membershipApiClient.patch(`users/${userId}`, {
      firstName,
      lastName,
    });
    return response.data;
  };
}

export const UsersInstance = new Users();
